import { useScope } from "@/hooks/useScope";

// function Inner({
//   queryDocument,
//   queryOptions,
// }: {
//   queryDocument: DocumentNode;
//   queryOptions: LazyQueryHookOptions;
// }) {
//   // preload the query using useLazyQuery
//   const [query] = useLazyQuery(queryDocument, queryOptions);

//   useEffect(() => {
//     // Wait 2 seconds before executing query
//     const timeout = setTimeout(() => {
//       query();
//     }, 5000);

//     return () => clearTimeout(timeout);
//   }, [query]);

//   return <></>;
// }

export function ApolloPreloader() {
  // get all objects that have a getReferenceValueOptions function
  // const objects = Object.values(OBJECTS).filter(
  //   (object) => object.getReferenceValueOptions
  // );
  const { entityIdentifiers } = useScope();

  // ensure at least one entity identifier is present and that it is not an empty string and not null
  if (entityIdentifiers.length === 0) {
    return null;
  }

  return (
    <>
      {/* {objects.map((object) => {
        return (
          <Inner
            key={object.typename}
            queryDocument={
              object.getReferenceValueOptions(entityIdentifiers).query
            }
            queryOptions={
              object.getReferenceValueOptions(entityIdentifiers).queryOptions
            }
          />
        );
      })} */}
    </>
  );
}
